var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import cx from 'classnames';
import styles from './Container.module.css';
export var WidthBehaviour;
(function (WidthBehaviour) {
    WidthBehaviour["FullPage"] = "fullPage";
    WidthBehaviour["FullContent"] = "fullContent";
    WidthBehaviour["LimitedContent"] = "limitedContent";
})(WidthBehaviour || (WidthBehaviour = {}));
export const Container = (_a) => {
    var { tagName: Tag = 'div', className, widthBehaviour = WidthBehaviour.LimitedContent, children } = _a, rest = __rest(_a, ["tagName", "className", "widthBehaviour", "children"]);
    return (React.createElement(Tag, Object.assign({ className: cx(styles.component, className, {
            [styles['component-fullPage']]: widthBehaviour === WidthBehaviour.FullPage
        }) }, rest),
        React.createElement("div", { className: cx(styles.content, {
                [styles['content-fullPage']]: widthBehaviour === WidthBehaviour.FullPage
            }) }, widthBehaviour === WidthBehaviour.LimitedContent ? (React.createElement("div", { className: styles['contentExtra-limitedContent'] }, children)) : (children))));
};
//# sourceMappingURL=Container.js.map